import { useSuspenseQuery } from '@tanstack/react-query';
import { Suspense } from 'react';
import { networksQueryOptions } from '#api/networks.queries.ts';
import { HeaderButtons } from '#components/patterns/header-buttons/HeaderButtons.tsx';
import { TableLayout } from '#components/patterns/layouts/table/TableLayout.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { NetworksList } from '../list/NetworksList.tsx';

export function NetworksPage() {
  const {
    data: { data: networks },
    isFetching,
  } = useSuspenseQuery(networksQueryOptions);

  // No empty view since we have "GetStartedPage"

  return (
    <TableLayout
      header={
        <PageHeader title="Networks" preventTitleWrap={true}>
          <HeaderButtons />
        </PageHeader>
      }
    >
      <Suspense fallback={<LoadingSpinner />}>
        <NetworksList data={networks} isFetching={isFetching} />
      </Suspense>
    </TableLayout>
  );
}
